import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { configureAmplify } from './lib/amplify';
import { AuthProvider, useAuth } from './lib/auth';
import { LandingPage } from './pages/LandingPage';
import { WelcomePage } from './pages/WelcomePage';
import { DashboardPage } from './pages/DashboardPage';

configureAmplify();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 0,
    },
  },
});

function AppContent() {
  const { status } = useAuth();
  const [showAuth, setShowAuth] = useState(false);

  if (status === 'loading') return (
    <div className="min-h-screen bg-sand-50 flex items-center justify-center">
      <span className="inline-block w-8 h-8 border-2 border-sand-300 border-t-adventure rounded-full animate-spin" />
    </div>
  );
  if (status === 'authenticated') return <DashboardPage />;
  if (status === 'confirm_signup' || showAuth) return <WelcomePage />;
  return <LandingPage onGetStarted={() => setShowAuth(true)} />;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </QueryClientProvider>
  );
}
